<ng-container *transloco="let t">
  <tui-textfield
    data-testid="input"
    ngDefaultControl
    tuiChevron
    [content]="selectedLocaleContent"
    [tuiTextfieldCleaner]="false">
    <input tuiSelect [ngModel]="value" [placeholder]="placeholder" (ngModelChange)="onSelectChange($event)" />

    <tui-data-list-wrapper
      *tuiDropdown
      new
      [emptyContent]="t('Aucun résultat')"
      [itemContent]="localesContent"
      [items]="locales" />
  </tui-textfield>

  <ng-template #selectedLocaleContent>
    <div class="flex items-center">
      <img
        class="mr-2 h-6 w-8 rounded-sm border border-border-normal object-cover"
        [alt]="selectedLocale.nativeName"
        [src]="selectedLocale.code | localeFlag | tuiFlag" />
      <p>{{ selectedLocale.nativeName | capitalize }}</p>
    </div>
  </ng-template>

  <ng-template #localesContent let-locale>
    <div class="flex items-center">
      <img
        class="mr-2 h-6 w-8 rounded-sm border border-border-normal object-cover"
        [alt]="locale.nativeName"
        [src]="locale.code | localeFlag | tuiFlag" />
      <p>{{ locale.nativeName | capitalize }}</p>
    </div>
  </ng-template>
</ng-container>
